<mat-horizontal-stepper [linear]="true" #stepper appSelectionChangeScrollInvalidControl appStepperScrollControl>
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup" #firstFormGroupDirective="ngForm" appSubmitScrollInvalidControl>
      <ng-template matStepLabel>Daten</ng-template>
      <ng-template matStepperIcon="edit">
        <div class="icon--only icon--check"></div>
      </ng-template>
      <div class="infotext" *ngIf="(!expertMode && translateService.get('RECHTSSCHUTZINFOTEXT', { produktName:'Rechtsschutzversicherung', produktLink: 'https://www.hdi.at/downloads/produktblaetter/rechtschutz_versicherung_privatbereich.pdf', deckungsUmfangLink: 'https://www.hdi.at/downloads/formulare/deckungsumfang_rechtsschutz.pdf'}) | async) as res" [innerHTML]="res"></div>
      <div class="infotext" *ngIf="(expertMode && translateService.get('RECHTSSCHUTZINFOTEXTEXPERT', { produktName:'Rechtsschutzversicherung', produktLink: 'https://www.hdi.at/downloads/produktblaetter/rechtschutz_versicherung_privatbereich.pdf', deckungsUmfangLink: 'https://www.hdi.at/downloads/formulare/deckungsumfang_rechtsschutz.pdf'}) | async) as res" [innerHTML]="res"></div>
      <div class="row">       
        <div class="col col-xs-12 col-sm-12">
          <div class="input">
            <app-label [control]="beginndatum" class="input-date-picker__label" for="beginndatum">{{ expertMode ? 'Beginndatum:' : 'Wann soll der Vertragsbeginn sein?' }}</app-label>
            <mat-form-field>
              <input matInput id="beginndatum" [matDatepicker]="beginndatumPicker" [min]="beginndatumMinDate" [max]="beginndatumMaxDate" placeholder="TT.MM.JJJJ" formControlName="beginndatum">
              <mat-datepicker-toggle matSuffix [for]="beginndatumPicker"></mat-datepicker-toggle>
              <mat-datepicker #beginndatumPicker></mat-datepicker>
              <mat-error *ngIf="beginndatum.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="beginndatum.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': beginndatumMinDate | date} }}</mat-error>
              <mat-error *ngIf="beginndatum.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': beginndatumMaxDate | date} }}</mat-error>
            </mat-form-field>
          </div>
        </div>        
      </div>
      <div id="leistungsuebersicht" *ngIf="(leistungsuebersicht$ | async) as leistungsuebersicht">
        <div id="leistungsuebersicht_desktop" class="row">
          <div class="col col-xs-12 col-sm-12">
            <div>
              <div class="input_radio">
                <div class="leistungsuebersicht-matrix">
                  <mat-radio-group id="paketId" formControlName="paketId">
                    <table mat-table [dataSource]="leistungsuebersicht.Leistungen">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Leistungsübersicht</th>
                        <td mat-cell *matCellDef="let leistung">
                          <mat-expansion-panel class="leistung">
                            <mat-expansion-panel-header>
                              {{ leistung.Name }}
                            </mat-expansion-panel-header>
                            <p *ngIf="leistung.Beschreibung" [innerHTML]="currencyService.styleCustomCurrency(leistung.Beschreibung)"></p>
                            <p *ngIf="leistung.Info" [innerHTML]="currencyService.styleCustomCurrency(leistung.Info)" class="info"></p>
                          </mat-expansion-panel>
                        </td>
                        <td mat-footer-cell *matFooterCellDef><label for="paketId">Paketauswahl:</label></td>
                      </ng-container>
                      <ng-container *ngFor="let paket of leistungsuebersicht.Pakete;let i=index" [matColumnDef]="'paket' + paket.PaketId">
                        <th mat-header-cell *matHeaderCellDef>
                          <div>
                            <b>PAKET {{ paket.PaketId }}</b>
                            <div class="package-name">{{ paket.Name }}</div>
                          </div>
                        </th>
                        <td mat-cell *matCellDef="let leistung">
                          <img class="rs-check-icon" *ngIf="leistung.In && leistung.In[i] === true" src="assets/img/check-icon-rechtsschutz-export.png">
                        </td>
                        <td mat-footer-cell *matFooterCellDef><mat-radio-button [value]="paket.PaketId"></mat-radio-button></td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="leistungsuebersichtColumns(leistungsuebersicht.Pakete); sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: leistungsuebersichtColumns(leistungsuebersicht.Pakete);"></tr>
                      <tr mat-footer-row *matFooterRowDef="leistungsuebersichtColumns(leistungsuebersicht.Pakete)"></tr>
                    </table>
                  </mat-radio-group>
                </div>
                <mat-error *ngIf="paketId.hasError('required') && firstFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </div>
            </div>
          </div>
        </div>
        <div id="leistungsuebersicht_mobile">
          <div class="custom_selection">
            <mat-selection-list [multiple]="false" [class]="paketId.hasError('required') ? 'ng-invalid' : ''" (selectionChange)="selectionChange($event.option)">
              <div class="row" *ngFor="let paket of leistungsuebersicht.Pakete;let i=index">
                <div class="col col-xs-12 col-sm-12">
                  <div class="teaser-standard">
                    <div class="teaser-standard__content">
                      <mat-expansion-panel class="leistung">
                        <mat-expansion-panel-header>
                          <h6>{{ paket.Name }}<br />PAKET {{ paket.PaketId }}</h6>
                        </mat-expansion-panel-header>
                        <div *ngFor="let leistung of leistungsuebersicht.Leistungen">
                          <mat-expansion-panel *ngIf="leistung.In && leistung.In[i] === true">
                            <mat-expansion-panel-header>
                              {{ leistung.Name }}
                            </mat-expansion-panel-header>
                            <p *ngIf="leistung.Beschreibung" [innerHTML]="currencyService.styleCustomCurrency(leistung.Beschreibung)"></p>
                            <p *ngIf="leistung.Info" [innerHTML]="currencyService.styleCustomCurrency(leistung.Info)" class="info"></p>
                          </mat-expansion-panel>
                        </div>
                      </mat-expansion-panel>
                      <mat-list-option [value]="paket" [selected]="paket.PaketId === paketId.value">
                        Paketauswahl
                      </mat-list-option>
                    </div>
                  </div>
                </div>
              </div>
            </mat-selection-list>
            <mat-error *ngIf="paketId.hasError('required') && firstFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="custom_select">
            <app-label [control]="fuerWen" class="custom-select__label" for="fuerWen">Für wen soll der Versicherungsschutz bestehen?</app-label>
            <mat-form-field>
              <mat-select id="fuerWen" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="fuerWen">
                <mat-option *ngFor="let option of getFuerWenOptions() | async" [value]="option">{{ option.Value }}</mat-option>
              </mat-select>
              <mat-error *ngIf="fuerWen.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="input_radio">
            <app-label [control]="berufAusschluss" for="berufAusschluss">
              <ng-container *ngIf="expertMode; else dkText">Übt der/die Versicherungsnehmer:In</ng-container>
              <ng-template #dkText>Üben Sie</ng-template>
              oder eine mitversicherte Person einen der folgenden Berufe aus?
              Rechtsanwält:innen, Notar:innen, Anlage-, Vermögens- und Steuerberater:innen sowie sämtliches Flugpersonal (Cockpit- und Kabinenbesatzung)
            </app-label>
              <mat-radio-group id="berufAusschluss" [formControl]="berufAusschluss">
              <mat-radio-button value="ja">Ja</mat-radio-button>
              <mat-radio-button value="nein">Nein</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="berufAusschluss.hasError('required') && firstFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
            <div class="text_info" *ngIf="berufAusschluss.hasError('invalid')">
              <label class="custom-select__label red-error-text-circle" for="lenkerberechtigung">Leider bieten wir für Personen, welche einen der in der obigen Frage beschriebenen Berufe ausüben, keine Rechtsschutzversicherung an.</label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ANNAHMERICHTLINIENINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="teaser">
            <p><strong>Zusatzleistungen bei Deckungserweiterung</strong></p>
            <p>Die Produkterweiterung „Top-Recht§vorteil“ bietet eine erhöhte Versicherungssumme von <span class="custom_currency">€ 200.000,-</span> und den angeführten Zusatzleistungen:</p>
            <ul>
              <li>
                <div class="text_info">
                  <label for="vorsatzdelikte">Vorsatzdelikte</label>
                  <div class="info">
                    <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('VORSATZDELIKTE') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                  </div>
                </div>
              </li>
              <li>Ermittlungsverfahren bis <span class="custom_currency">€ 10.000,-</span> statt <span class="custom_currency">€ 5.000,-</span> inkl. USt.</li>
              <li>Mediation bis <span class="custom_currency">€ 5.000,-</span> inkl. USt.</li>
              <li>Arbeitsgerichts-Rechtsschutz mit Sublimit <span class="custom_currency">€ 80.000,-</span> statt <span class="custom_currency">€ 50.000,-</span> pro Versicherungsfall und Versicherungsjahr</li>
              <li *ngIf="paketId.value === 4 || paketId.value === 5">Arbeitsgerichts-Rechtsschutz bis <span class="custom_currency">€ 80.000,-</span></li>
              <li>Gutachter-Rechtsschutz bis <span class="custom_currency">€ 5.000,-</span> statt <span class="custom_currency">€ 3.000,-</span> inkl. USt.</li>
            </ul>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="input_radio">
            <app-label [control]="deckungsumfangErhoehen" for="deckungsumfangErhoehen">Möchten Sie den <a href="https://www.hdi.at/downloads/formulare/deckungsumfang_rechtsschutz.pdf" target="_blank">Deckungsumfang</a> {{ expertMode? 'der Rechtsschutzversicherung' : 'Ihrer Rechtsschutzversicherung' }} mit &bdquo;Top-Recht§vorteil&ldquo; erweitern?</app-label>
            <mat-radio-group id="deckungsumfangErhoehen" formControlName="deckungsumfangErhoehen">
              <mat-radio-button value="ja">Ja</mat-radio-button>
              <mat-radio-button value="nein">Nein</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="deckungsumfangErhoehen.hasError('required') && firstFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="input" *ngIf="showKennzeichen">
            <app-label [control]="kennzeichen" class="input__label" for="kennzeichen">Kfz-Kennzeichen:</app-label>
            <mat-form-field>
              <input matInput id="kennzeichen" placeholder="W-1234AB" [value]="kennzeichen.value | uppercase" formControlName="kennzeichen">
              <mat-error *ngIf="kennzeichen.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="kennzeichen.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <p *ngIf="rsResult?.Aktion"><strong>Für Ihre aktuelle Auswahl wurde der Rabatt der Rechtsschutz-Aktion {{ rsResult.AktionBezeichnung }} berücksichtigt.</strong></p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col col-xs-12 col-sm-6 col-lg-4 custom-flex-grid">
          <button *ngIf="showWeiter" mat-button matStepperNext class="button--primary icon--after icon--right">Weiter</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="secondFormGroup">
    <form [formGroup]="secondFormGroup" #secondFormGroupDirective="ngForm" appSubmitScrollInvalidControl>
      <ng-template matStepLabel>Berechnung</ng-template>
      <ng-template matStepperIcon="edit">
        <div class="icon--only icon--check"></div>
      </ng-template>
      <div id="berechnung">
        <div class="row">
          <div class="col col-xs-12 col-sm-12">
            <div class="custom_select">
              <div class="text_info">
                <app-label [control]="zahlungsArtId" class="custom-select__label" for="zahlungsart">Prämie für folgende Zahlungsweise anzeigen:</app-label>
                <div class="info">
                  <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ZAHLUNGSWEISEINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                </div>
              </div>
              <mat-form-field>
                <mat-select id="zahlungsArtId" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="zahlungsArtId" [compareWith]="lookupService.compareValues">
                  <mat-option *ngFor="let za of dataService.zahlungsarten | async" [value]="za">{{ za.Value }}</mat-option>
                </mat-select>
                <mat-error *ngIf="zahlungsArtId.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="label-infotext mindestpraemie-infotext">Die Zahlung mittels Zahlschein ist nur bei jährlicher oder halbjährlicher Zahlungsweise möglich.</div>
      <div class="value-grid" *ngIf="zahlungsArtId.value">
        <div class="row">
          <div class="col col-xs-12 col-sm-12"><strong>Prämienberechnung</strong></div>
          <div class="col col-xs-12 col-sm-12 label-infotext praemienberechnung-infotext">Alle Prämien verstehen sich als Bruttoprämien inkl. Versicherungssteuer.</div>
        </div>
        <div class="row praemie-l1">
          <div class="col col-xs-12 col-sm-6"><div>Versicherungssumme (wertgesichert VPI 2000)</div></div>
          <div class="col col-xs-12 col-sm-1 text-right"><span class="custom_currency">{{ versicherungssumme }}</span></div>
          <div class="col col-xs-12 col-sm-5"></div>
        </div>
        <div class="row praemie-summe">
          <div class="col col-xs-12 col-sm-6"><div><strong>Summe</strong></div></div>
          <div class="col col-xs-12 col-sm-1 text-right"><span class="custom_currency"><strong>{{ rsResult?.Gesamt  | customCurrency }}</strong></span></div>
          <div class="col col-xs-12 col-sm-5"></div>
        </div>
      </div>
      <div class="row">
        <div class="col col-xs-12 col-lg-4 custom-flex-grid">
          <button mat-button matStepperPrevious class="button--secondary icon--before icon--left">Zurück</button>
        </div>
        <div class="col col-xs-12 col-lg-4 custom-flex-grid" *ngIf="!offertAntrag && !verifyOffert">
          <button mat-button class="button--primary icon--after icon--right" (click)="stepper.selectedIndex = 2">Angebot einholen</button>
          <label class="button-label">Hier können Sie sich ein unverbindliches Angebot einholen.</label>
        </div>
        <div class="col col-xs-12 col-lg-4 custom-flex-grid">
          <button mat-button class="button--primary icon--after icon--right" (click)="stepper.selectedIndex = offertAntrag || verifyOffert ? 2 : 3">Antrag erstellen</button>
          <label class="button-label">Hier können Sie einen verbindlichen Antrag erstellen.</label>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="thirdFormGroup" [optional]="true" *ngIf="!offertAntrag && !verifyOffert">
    <form [formGroup]="thirdFormGroup" #thirdFormGroupDirective="ngForm" appSubmitScrollInvalidControl>
      <ng-template matStepLabel>Angebot</ng-template>
      <app-offert [parentFormGroupDirective]="thirdFormGroupDirective" [formGroup]="offert" [expertMode]="expertMode" [privatperson]="true" [showEinzelunternehmen]="false" [anredenPrivatperson]="true" [antragVersicherungsnehmer]="antragVersicherungsnehmer"></app-offert>
      <app-vereinbarung-kommunikation [parentFormGroupDirective]="thirdFormGroupDirective" [vereinbarungKommunikation]="vereinbarungKommunikationOffert" [antrag]="false" [expertMode]="expertMode"></app-vereinbarung-kommunikation>
      <app-datenschutz-policy [parentFormGroupDirective]="thirdFormGroupDirective" [datenschutzPolicy]="datenschutzPolicyOffert" [showDatenschutzPolicy]="!expertMode" [produktArt]="produktArt.Rechtschutz"></app-datenschutz-policy>
      <div #angebotTeaser *ngIf="showAngebotTeaser">
        <div *ngIf="expertMode; then angebotTeaserTemplateExpert; else angebotTeaserTemplate"></div>
        <ng-template #angebotTeaserTemplateExpert>
          <div class="teaser">
            <h5>Vielen Dank, Ihr Angebot ist bereit!</h5>
            <br /><div class="icon--before icon--download"><strong>&nbsp;&nbsp;&nbsp;Jetzt herunterladen</strong></div><br />
            <p>Sie können Ihr Angebot <a [routerLink]="[]" (click)="downloadDocument(pdfDataOffert, 'Angebot.pdf')">hier herunterladen (PDF)</a>.</p>
            <p>Stimmt etwas nicht? Ändern Sie einfach Ihre Daten und fordern Sie ein neues Angebot an.</p>
          </div>
        </ng-template>
        <ng-template #angebotTeaserTemplate>
          <div class="teaser">
            <h5>Vielen Dank, Ihr Angebot ist bereit!</h5>
            <br /><div class="icon--before icon--mail"><strong>&nbsp;&nbsp;&nbsp;So geht's weiter</strong></div><br />
            <p>Das Angebot mit allen Dokumenten schicken wir Ihnen per Mail an <i>{{ offertComponent.versicherungsnehmerComponent.email.value }}</i>. Im Mail finden Sie einen Link, um aus dem Angebot einen verbindlichen Antrag zu erstellen. Dieser Link ist 48 Stunden lang gültig. Falls Sie das Mail nicht gleich erhalten, sehen Sie bitte im Spam-Ordner nach.</p>
            <br /><div class="icon--before icon--download"><strong>&nbsp;&nbsp;&nbsp;Jetzt herunterladen</strong></div><br />
            <p>Sie können Ihr Angebot <a [routerLink]="[]" (click)="downloadDocument(pdfDataOffert, 'Angebot.pdf')">hier herunterladen (PDF)</a>. Stimmt etwas nicht? Ändern Sie einfach Ihre Daten und fordern Sie ein neues Angebot an.</p>
          </div>
        </ng-template>
      </div>
      <app-friendlycaptcha-widget #thirdFormGroupFriendlycaptchaWidget></app-friendlycaptcha-widget>
      <div class="row justify-content-between">
        <div class="col col-xs-12 col-sm-6 col-lg-4 custom-flex-grid">
          <button mat-button matStepperPrevious class="button--secondary icon--before icon--left" (click)="resetPdfData()">Zurück</button>
        </div>
        <div class="col col-xs-12 col-sm-6 col-lg-4 custom-flex-grid" *ngIf="!showAngebotTeaser">
          <button appPreventClickProcessing mat-button class="button--primary icon--after icon--right" (processClickEvent)="createOffert$.next()">Angebot einholen</button>
          <label class="button-label">Hier können Sie sich ein unverbindliches Angebot einholen.</label>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="fourthFormGroup" label="Antrag">
    <form [formGroup]="fourthFormGroup" #fourthFormGroupDirective="ngForm" appSubmitScrollInvalidControl>
      <ng-template matStepLabel>Antrag</ng-template>
      <app-antrag [parentFormGroupDirective]="fourthFormGroupDirective" [formGroup]="antrag" [showLaufzeit]="true" [showWeitereWohneinheiten]="showWeitereWohneinheiten" [expertMode]="expertMode" [privatperson]="true" [_beginndatum]="beginndatum.value ? beginndatum.value.toDate() : null"
                  [showEinzelunternehmen]="false" [anredenPrivatperson]="true" [zahlungsart]="zahlungsArtId" [zahlungsarten]="dataService.zahlungsarten" [offertVersicherungsnehmer]="offertVersicherungsnehmer"></app-antrag>
      <app-rs-antrag [parentFormGroupDirective]="fourthFormGroupDirective" [datenBeratungsprotokoll]="datenBeratungsprotokoll" [weitereFragen]="antragWeitereFragen" [produkt]="getProdukt()" [versicherungssumme]="versicherungssumme" [rsResult]="rsResult" [paket]="paket" [expertMode]="expertMode" (kuendigungRisikenEvent)="setKuendigungRisiken($event)"></app-rs-antrag>
      <div class="row justify-content-between">
        <div class="col col-xs-12 col-sm-6 col-lg-4 custom-flex-grid">
          <button mat-button class="button--secondary icon--before icon--left" (click)="stepper.selectedIndex = 0">Zurück</button>
        </div>
        <div class="col col-xs-12 col-sm-6 col-lg-4">
          <div class="custom-flex-grid" *ngIf="expertMode || kuendigungRisiken === false">
            <button mat-button matStepperNext class="button--primary icon--after icon--right">Zur Zusammenfassung</button>
            <label class="button-label">Hier können Sie einen verbindlichen Antrag erstellen.</label>
          </div>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="fifthFormGroup" label="Zusammenfassung">
    <form [formGroup]="fifthFormGroup" #fifthFormGroupDirective="ngForm" appSubmitScrollInvalidControl>
      <ng-template matStepLabel><div class="mat-step-icon-container"><mat-icon>check</mat-icon></div></ng-template>
      <app-zusammenfassung [antragComponent]="antragComponent" [expertMode]="expertMode" (korrekturEvent)="zusammenfassungKorrektur()"></app-zusammenfassung>
      <app-rs-zusammenfassung [parentFormGroupDirective]="fifthFormGroupDirective" [formGroup]="rsZusammenfassung" [expertMode]="expertMode" [produkt]="stepper.selectedIndex === 4 ? getProdukt() : {}" [paket]="paket"
                              [rsAntragComponent]="rsAntragComponent" [versicherungssumme]="versicherungssumme" [rsResult]="rsResult" (korrekturEvent)="zusammenfassungKorrektur()"></app-rs-zusammenfassung>
      <div #antragTeaser *ngIf="showAntragTeaser">
        <div *ngIf="expertMode; then antragTeaserTemplateExpert; else antragTeaserTemplate"></div>
        <ng-template #antragTeaserTemplateExpert>
          <div class="teaser">
            <h5>Vielen Dank für Ihren Antrag!</h5>
            <br /><div class="icon--before icon--download"><strong>&nbsp;&nbsp;&nbsp;Jetzt herunterladen</strong></div><br />
            <p>Sie können Ihren Antrag <a [routerLink]="[]" (click)="downloadDocument(pdfDataAntrag, 'Antrag.pdf')">hier herunterladen (PDF)</a>. Falls Sie noch Änderungen vornehmen möchten, stehen die Antragsdaten im Vertriebspartnerportal unter Service/Meine Anträge zur Verfügung. Klicken Sie für eine Änderung auf den Button "Bearbeiten".</p>
            <br /><div class="icon--before icon--mail"><strong>&nbsp;&nbsp;&nbsp;So geht's weiter</strong></div><br />
            <p>Bitte senden Sie den unterzeichneten Antrag mit allen eventuell notwendigen Unterlagen an Ihren Vermittlerbetreuer oder Ihre Landesdirektion.</p>
          </div>
        </ng-template>
        <ng-template #antragTeaserTemplate>
          <div class="teaser">
            <h5>Vielen Dank für Ihren Antrag!</h5>
            <br /><div class="icon--before icon--mail"><strong>&nbsp;&nbsp;&nbsp;So geht's weiter</strong></div><br />
            <p>Sie erhalten Ihre Versicherungspolizze in Kürze per Post. Bitte beachten Sie, dass die Versicherung erst durch das fristgerechte Bezahlen der ersten Prämie zustande kommt! Als Vertragsbeginn gilt der <strong>{{ this.antragComponent.beginndatum.value | date }}</strong>. Sollten wir noch Fragen haben oder falls eine Versicherung mit Ihren Angaben nicht möglich ist, melden wir uns verlässlich.</p>
            <p>Für Ihre Unterlagen schicken wir Ihnen den Antrag mit allen Dokumenten per Mail an {{ antragComponent.versicherungsnehmerComponent.email.value }}. Falls Sie das Mail nicht gleich erhalten, sehen Sie bitte im Spam-Ordner nach.</p>
            <br /><div class="icon--before icon--download"><strong>&nbsp;&nbsp;&nbsp;Jetzt herunterladen</strong></div><br />
            <p>Sie können Ihren Antrag <a [routerLink]="[]" (click)="downloadDocument(pdfDataAntrag, 'Antrag.pdf')">hier herunterladen (PDF)</a>. <span [innerHTML]="translateService.get('AENDERUNGENKONTAKTINFO') | async"></span></p>
          </div>
        </ng-template>
      </div>
      <app-friendlycaptcha-widget #fifthFormGroupFriendlycaptchaWidget></app-friendlycaptcha-widget>
      <div class="row justify-content-between">
        <div class="col col-xs-12 col-sm-6 col-lg-4 custom-flex-grid">
          <button mat-button matStepperPrevious class="button--secondary icon--before icon--left" *ngIf="expertMode || kuendigungRisiken === false" (click)="resetPdfData()">Zurück</button>
        </div>
        <div class="col col-xs-12 col-sm-6 col-lg-4">
          <div class="custom-flex-grid" *ngIf="(expertMode || kuendigungRisiken === false) && !showAntragTeaser">
            <button appPreventClickProcessing mat-button class="button--primary icon--after icon--right" (processClickEvent)="createAntrag$.next()">{{ expertMode ? 'Antrag erstellen' : 'Antrag senden' }}</button>
          </div>
        </div>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>

